import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#FF3A5E"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M32.708 25.6797C31.6218 23.4361 28.8962 22.5343 26.6862 23.6874L18.3941 28.014C16.9481 28.7685 16.0415 30.2642 16.0415 31.8951L16.0415 37.8685C16.0415 38.3867 16.5883 38.7224 17.0503 38.4879L30.7299 31.5467C32.8778 30.4568 33.7575 27.8476 32.708 25.6797Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.3853 22.8495C17.4507 25.034 20.0883 25.9369 22.2689 24.8635L30.2723 20.9239C31.7688 20.1872 32.7166 18.6642 32.7166 16.9962L32.7166 11.1114C32.7166 10.5981 32.179 10.2621 31.7176 10.4872L18.4064 16.9799C16.2275 18.0426 15.3226 20.6706 16.3853 22.8495Z",
                fill: "white"
            })
        ]
    });
